import { useModalBox } from '@ezio/ui/overlays/modal-box'

const { modalBox } = useModalBox()

export const scaModalBox = {
    show: (operationId: string = null, onSuccess = () => {}) => {
        return new Promise(async (r) => {
            modalBox.show({
                component: () => import('@ezio/features/sca/components/ScaWaitingScreen.vue'),
                backgroundClose: false,
                props: {
                    operationId
                }
            })
        })
    },
    dismiss: () => {
        modalBox.dismiss()
    }
}
